
import { defineComponent, PropType } from "vue";
import { RouteLocationRaw, RouterLink } from "vue-router";

import common from "../styles/common.module.less";
import { Icon } from "./icons";

export default defineComponent({
  name: "XiyouSectionHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    moreTo: {
      type: [String, Object] as PropType<RouteLocationRaw>,
      default: undefined,
    },
    moreText: { type: String, default: "更多" },
  },
  setup(props) {
    return () => (
      <div class={common.sectionHeader}>
        <div class={common.sectionTitleWrap}>
          <span class={common.sectionBar} />
          <h2 class={common.sectionTitle}>{props.title}</h2>
          {props.subtitle ? (
            <span class={common.sectionSubtitle}>{props.subtitle}</span>
          ) : null}
        </div>
        {props.moreTo ? (
          <RouterLink class={common.sectionMore} to={props.moreTo}>
            {props.moreText}
            <Icon name="arrow-right" />
          </RouterLink>
        ) : null}
      </div>
    );
  },
});
